<template>
  <div class="layout-cont">
    <div class="layout-hd">
      <img class="logo-img" src="@/assets/images/logo_bw.png">
      <div v-if="showNav" class="nav-cont">
        <a class="nav-li" :class="{ active: navIndex === 'Cervix' }" href="javascript:void(0)" @click="navIndex = 'Cervix'">体测介绍</a>
        <a class="nav-li" :class="{ active: navIndex === 'Report' }" href="javascript:void(0)" @click="navIndex = 'Report'">查看报告</a>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <div class="login-info">
          <el-dropdown trigger="click">
            <div class="el-dropdown-link">
              <div style="display: flex; align-items: center">
                <span class="admin-name" style="color: #fff; cursor: pointer">{{
                  name
                }}</span>
                <i class="el-icon-arrow-down el-icon--right" />
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logout">登出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="layout-bd">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { logout } from "@/api/user";

export default {
  props: {
    showNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navIndex: "Cervix",
    };
  },
  computed: {
    ...mapState("user", ["name", "roles"]),
  },
  watch: {
    navIndex: {
      handler(value) {
        this.$emit("navSwitch", value);
      },
      deep: true,
    },
  },
  created() {
    if (this.$route["query"]["navIndex"]) {
      this.navIndex = this.$route["query"]["navIndex"];
    }
  },
  methods: {
    logout() {
      logout({}).then(() => {
        this.$router.push("/login");
        this.$router.go(0);
        this.$store.dispatch("user/resetToken");
      });
    },
    toggleCollapsed() {
      this.$store.dispatch("app/toggleSideBar");
    },
    goHome() {
      this.$router.push("/index");
    },
    handleEmitNavIndex(val) {
      this.navIndex = val;
    },
  },
};
</script>

<style lang="less" scoped>
.layout-cont {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .layout-hd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(66px * 0.75);
    padding: 0 calc(30px * 0.75);
    background-color: rgba(0, 0, 0, 1);
    .logo-img {
      width: calc(50px * 0.75);
    }
  }
  .layout-bd {
    flex: 1;
    position: relative;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.nav-cont {
  .nav-li {
    display: inline-block;
    padding: calc(9px * 0.75) calc(14px * 0.75);
    margin: 0 calc(36px * 0.75);
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: calc(18px * 0.75);
    color: #ffffff;
    line-height: calc(26px * 0.75);
    &.active {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: calc(3px * 0.75);
        background-color: #ffffff;
      }
    }
  }
}
</style>
